import { ITask } from '../../TInvoker';
import OperationCanceledError from '../../error/OperationCanceledError';

export default function findError(tasks: ReadonlyArray<ITask>): unknown {
    const errorTask = tasks
        .find((item) => item.result?.error
            && (item.result?.error as OperationCanceledError).details?.code !== 'ECANCEL');

    if (errorTask) {
        return errorTask.result?.error;
    }

    return tasks
        .find((item) => item.result?.error)?.result?.error;
}
